<template>
  <div
    class="fixed inset-0 bg-[rgba(0,0,0,0.4)] z-[1111] flex justify-end overflow-y-auto"
    id="popup-content"
    @click.self="close"
  >
    <div
      class="relative w-full lg:w-[80%] max-h-screen bg-[#f8f8f8] px-[12px] py-[30px] md:p-[40px] overflow-auto"
    >
      <div class="shadow-none bg-transparent">
        <div class="flex items-start justify-between">
          <p class="text-[#353535] text-[20px] leading-[20px] font-semibold">
            Stock Transfer
          </p>
          <button
            class="text-2xl text-[#353535] outline-none focus:outline-none"
            type="button"
            @click="close"
          >
            <span class="mdi mdi-close"></span>
          </button>
        </div>
      </div>
      <div
        class="bg-white p-1 rounded-[4px] flex items-center gap-[16px] mt-[16px]"
      >
        <p class="text-[#2463EB] text-[20px] leading-[20px] font-bold">
          {{ locationName }}
        </p>
      </div>
      <div class="bg-white p-1 rounded-[4px] mt-[16px]">
        <div class="flex items-center justify-between w-full mb-[16px]">
          <h4 class="text-[#000000] text-[14px] leading-[20px] font-semibold">
            Product transfer
          </h4>
          <button
            class="bg-[#2463EB] border-[#2463EB] border-[1.5px] px-[24px] py-[12px] text-white text-[14px] leading-[16.94px] font-medium flex gap-[5px] items-center max-w-max rounded-[8px]"
            @click="viewAdds"
          >
            <span class="mdi mdi-plus text-white"></span>
            Add Product
          </button>
        </div>
        <div class="table-responsive">
          <table class="table text-nowrap no-footer">
            <thead class="bg-[#ECF9FF]">
              <tr>
                <th
                  class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                >
                  Transfer From
                </th>
                <th
                  class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                >
                  Transfer To
                </th>
                <th
                  class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                >
                  Product
                </th>
                <th
                  class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                >
                  Unit Price x QTY
                </th>
                <th
                  class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                >
                  Stock Value
                </th>
                <th
                  class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                >
                  Transferred By
                </th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in transferDetails" :key="index">
                <td
                  class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
                >
                  {{ locationName }}
                </td>
                <td
                  class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
                >
                  {{ item.location }}
                </td>
                <td
                  class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
                >
                  {{ item.name }}
                </td>
                <td
                  class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
                >
                  &#8358;{{ item.price }} X {{ item.quantity }}
                </td>
                <td
                  class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
                >
                  &#8358;{{ formatMoney(item.quantity * item.price) }}
                </td>
                <td
                  class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
                >
                  {{ user.displayName }}
                </td>
                <td>
                  <span
                    class="text-[#DC2828] cursor-pointer text-[14px] leading-[20px] font-normal"
                    @click.prevent="remove(index)"
                  >
                    Delete
                  </span>
                </td>
              </tr>
              <tr v-if="!transferDetails.length">
                <td colspan="12">
                  <div class="text-center" style="padding-top: 50px">
                    <span
                      style="font-size: 4.615rem"
                      class="mdi mdi-crosshairs-gps"
                    ></span>
                  </div>
                  <div class="text-center">No products selected</div>
                </td>
              </tr>
            </tbody>
          </table>
          <div
            class="flex items-center justify-end gap-[10px] max-w-[400px] w-full ml-auto"
            v-if="transferDetails.length"
          >
            <button
              class="border-[#96a0b5] border-solid border-[1.5px] py-[16px] px-[24px] rounded-[8px] text-[16px] font-medium leading-[20px] w-full"
              type="button"
              @click.prevent="deleteAll"
            >
              Cancel
            </button>
            <button
              :disabled="isBusy || !transferDetails.length"
              class="border-[#2463EB] bg-[#2463EB] text-white border-solid border-[1.5px] py-[16px] px-[24px] rounded-[8px] text-[16px] font-medium leading-[20px] w-full"
              type="button"
              @click.prevent="confirmTransfer"
            >
              <span v-if="isBusyModal">Busy...</span>
              <span v-else>Transfer</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade py-1" id="mod-adds" role="dialog">
      <div class="modal-dialog mx-auto">
        <div class="modal-content p-[24px] bg-[#f8f8f8]">
          <div class="modal-header flex items-start justify-between p-0 m-0">
            <h4
              class="font-semibold text-[20px] leading-[24px] capitalize text-[#353535] pb-[16px]"
            >
              Create New Stock Transfer
            </h4>
            <button
              class="text-2xl text-[#353535]"
              type="button"
              data-dismiss="modal"
              aria-hidden="true"
            >
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="modal-body m-0 p-0">
            <div class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
              >
                Product/Unit</label
              >
              <div>
                <select
                  class="border-[#d0d5dd] bg-transparent border-solid border-[1.5px] p-[14px] rounded-[8px] w-full outline-none"
                  v-model="newItem.productIndex"
                  @change="onProductSelect($event)"
                >
                  <option value="null" selected disabled>All Orders</option>
                  <option
                    v-for="(p, index) in filteredProducts"
                    :key="p.id"
                    :value="index"
                  >
                    {{ p.name }} ({{ p.unit }}, {{ p.quantity }}pcs)
                  </option>
                </select>
                <ul v-if="v2.productId" class="parsley-errors-list filled">
                  <li class="parsley-required">Required.</li>
                </ul>
                <span
                  v-if="canShowCaution"
                  class="bg-warning text-white px-1 rounded"
                  style="padding: 0.2rem"
                >
                  <i class="fa fa-warning mt-1"></i>
                  <small>Product is <b>Low</b> on stock.</small>
                </span>
              </div>
            </div>
            <div class="pb-[16px]">
              <div class="flex items-center gap-[10px] w-full">
                <div class="w-[47%]">
                  <label
                    class="text-[#353535] font-medium text-[14px] leading-[20px]"
                  >
                    Available Quantity</label
                  >
                  <input
                    class="border-[#d0d5dd] bg-[#F5F5F1] border-solid border-[1.5px] p-[14px] rounded-[8px] w-full outline-none"
                    type="number"
                    readonly
                    v-model.number="newItem.availableQuantity"
                    disabled
                  />
                </div>
                <p class="m-0">X</p>
                <div class="w-[47%]">
                  <label
                    class="text-[#353535] font-medium text-[14px] leading-[20px]"
                  >
                    Cost Per unit</label
                  >
                  <p
                    class="border-[#d0d5dd] bg-[#F5F5F1] border-solid border-[1.5px] p-[14px] rounded-[8px] w-full m-0"
                  >
                    &#8358;{{ formatMoney(newItem.productPrice) }}
                  </p>
                </div>
              </div>
            </div>
            <div class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
              >
                Quantity of products to be transferred</label
              >
              <div>
                <input
                  class="border-[#d0d5dd] bg-transparent border-solid border-[1.5px] p-[14px] rounded-[8px] w-full outline-none"
                  :class="[{ 'is-invalid': v2.quantity || v2.quantityError }]"
                  type="number"
                  v-model.number="newItem.quantity"
                  :disabled="isQuantityLoading"
                  @input="onQuantityChange($event)"
                  placeholder="Enter quantity"
                />
                <ul v-if="v2.quantity" class="parsley-errors-list filled">
                  <li class="parsley-required">
                    Enter a number greater than 0
                  </li>
                </ul>
                <ul v-if="v2.quantityError" class="parsley-errors-list filled">
                  <li class="parsley-required">
                    Enter a number lower than available quantity
                  </li>
                </ul>
              </div>
            </div>
            <div class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >Transfer to:</label
              >
              <div>
                <select
                  class="border-[#d0d5dd] bg-transparent border-solid border-[1.5px] p-[14px] rounded-[8px] w-full outline-none"
                  :class="[{ 'is-invalid': v2.locationId }]"
                  placeholder="Select an option"
                  v-model="newItem.locationId"
                  @input="getSubLocationsById($event)"
                >
                  <option value="null" selected disabled
                    >Select destination</option
                  >

                  <option
                    v-for="loc in Locations"
                    :key="loc.id"
                    :value="loc.id"
                  >
                    {{ loc.name }}
                  </option>
                </select>

                <ul v-if="v2.locationId" class="parsley-errors-list filled">
                  <li class="parsley-required">Required.</li>
                </ul>
              </div>
            </div>
            <div class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
              >
                Storage Area:</label
              >
              <div>
                <select
                  class="border-[#d0d5dd] bg-transparent border-solid border-[1.5px] p-[14px] rounded-[8px] w-full outline-none"
                  :class="[{ 'is-invalid': v2.subLocationId }]"
                  placeholder="Select an option"
                  v-model="newItem.subLocationId"
                  :disabled="!newItem.locationId"
                >
                  <option value="null" selected disabled
                    >Select storage area</option
                  >
                  <option
                    v-for="loc in filteredSubLocations"
                    :key="loc.id"
                    :value="loc.id"
                  >
                    {{ loc.name }}
                  </option>
                </select>

                <ul v-if="v2.subLocationId" class="parsley-errors-list filled">
                  <li class="parsley-required">Required.</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="flex items-center gap-[8px] mt-[16px]">
            <button
              class="border-[##96a0b5] border-solid border-[1.5px] py-[16px] px-[24px] rounded-[8px] text-[16px] font-medium leading-[20px] w-full"
              type="button"
              data-dismiss="modal"
              @click.prevent="onAddCancel"
            >
              Cancel
            </button>
            <button
              :disabled="isBusyModal || isQuantityLoading"
              class="bg-[#2463eb] border-[##2463eb] border-solid border py-[16px] px-[24px] rounded-[8px] text-white text-[16px] font-medium leading-[20px] w-full"
              type="button"
              @click.prevent="add"
            >
              <span v-if="isBusyModal">Busy...</span>
              <span v-else>Add Product</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade py-1" id="mod-confirms" role="dialog">
      <div class="modal-dialog mx-auto">
        <div class="modal-content p-[24px] bg-[#f8f8f8]">
          <h4
            class="font-semibold text-[20px] leading-[20px] capitalize text-[#2463EB] pb-[16px]"
          >
            Confirm Stock Transfer
          </h4>
          <div class="m-0 p-0">
            <div class="pb-[16px] flex items-center">
              <h2
                class="font-normal text-[16px] text-[#96a0b5] md:max-w-[250px] w-full"
              >
                Transfer from:
              </h2>
              <span
                class="font-medium text-[16px] text-[#353535] leading-[19.36px]"
              >
                {{ locationName }}
              </span>
            </div>
            <div class="pb-[16px] flex items-center">
              <h2
                class="font-normal text-[16px] text-[#96a0b5] md:max-w-[250px] w-full"
              >
                Transferred By:
              </h2>
              <span
                class="font-medium text-[16px] text-[#353535] leading-[19.36px]"
              >
                {{ user.displayName }}
              </span>
            </div>
            <div v-for="(item, index) in transferDetails" :key="index">
              <div class="pb-[16px] flex items-center">
                <h2
                  class="font-normal text-[16px] text-[#96a0b5] md:max-w-[250px] w-full"
                >
                  Product name:
                </h2>
                <span
                  class="font-medium text-[16px] text-[#353535] leading-[19.36px]"
                >
                  {{ item.name }}
                </span>
              </div>
              <div class="pb-[16px] flex items-center">
                <h2
                  class="font-normal text-[16px] text-[#96a0b5] md:max-w-[250px] w-full"
                >
                  Stock Value:
                </h2>
                <p
                  class="font-medium text-[16px] text-[#353535] leading-[19.36px]"
                >
                  &#8358;{{ formatMoney(item.quantity * item.price) }}
                </p>
              </div>
            </div>
          </div>
          <div class="flex items-center gap-[8px] w-full">
            <button
              class="bg-[#fcfcfd] border-[##96a0b5] border-solid border-[1.5px] py-[16px] px-[16px] sm:px-[24px] text-[14px] md:text-[16px] rounded-[8px] text-[#96A0B5] font-medium leading-[20px] w-full outline-none focus:outline-none"
              type="button"
              @click.prevent="cancel"
            >
              Cancel
            </button>
            <button
              :disabled="isBusyModal"
              class="bg-[#2463eb] border-[##2463eb] border-solid border py-[16px] px-[16px] sm:px-[24px] text-[14px] md:text-[16px] rounded-[8px] text-white font-medium leading-[20px] w-full outline-none focus:outline-none"
              type="button"
              @click.prevent="makeTransfer"
            >
              <span v-if="isBusyModal">Busy...</span>
              <span v-else>Confirm</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { helper } from "@/helper";
import Select2 from "@/components/Select2";
import SystemPermissions from "@/permissions";
import Multiselect from "vue-multiselect";

export default {
  mixins: [SystemPermissions.Mixin],
  name: "settingsStockTransferCreate",
  props: ["close", "createLocationId"],
  components: {
    Select2,
    Multiselect,
  },
  data() {
    return {
      locationName: "",
      Locations: [],
      SubLocations: [],
      filteredSubLocations: [],
      canShowCaution: false,
      isQuantityLoading: false,
      isBusy: false,
      isBusyModal: false,
      products: [],
      filteredProducts: [],
      transferDetails: [],
      total: 0.0,
      newItem: {},
      v2: {
        productId: false,
        quantity: false,
        quantityError: false,
        locationId: false,
        subLocationId: false,
      },
    };
  },
  async created() {
    if (!this.hasPermission("Stock_Transfer_Create")) {
      this.$router.push("/restricted");
    }

    const id = this.createLocationId;

    this.getSubLocations();
    this.getLocations();

    if (id) {
      this.subLocationId = id;
      await this.initialize();
    }
  },
  computed: {
    user: function() {
      return this.$store.state.currentUser;
    },
  },
  watch: {
    transferDetails: {
      handler(newVal, oldVal) {
        const reducer = (a, b) => a + b;
        let newTotal = this.transferDetails
          .map((el) => +el.price * +el.quantity)
          .reduce(reducer, 0);
        this.total = newTotal;
      },
      deep: true,
    },
  },
  methods: {
    async getLocations() {
      await this.$http
        .get(
          "/Locations/getListNoPaging?active=true&parentId=" +
            this.user.parentId
        )
        .then(function(res) {
          this.Locations = res.body;
        })
        .catch(function() {});
    },
    checkQuantity(product) {
      if (this.transferDetails.length < 1)
        return (this.newItem.availableQuantity = product.quantity);
      const reducer = (a, b) => a + b;
      const totalQuantity = this.transferDetails
        .map((el) => {
          if (el.id === product.productId) return el.quantity;
        })
        .reduce(reducer, 0);
      this.newItem.availableQuantity = product.quantity - totalQuantity;
    },

    async getSubLocations() {
      await this.$http
        .get(
          "/SubLocations/getListNoPaging?active=true&parentId=" +
            this.user.parentId +
            "&locationId="
        )
        .then(function(res) {
          this.SubLocations = res.body;
        })
        .then((res) => {
          const subLocation = this.SubLocations.find(
            (el) => el.id === this.subLocationId
          );
          this.locationName = `${subLocation.location.name}, ${subLocation.name}`;
        })
        .catch(function(err) {});
    },

    async makeTransfer() {
      this.isBusyModal = true;
      const payload = {
        sourceSubLocationId: this.subLocationId,
        transfers: this.transferDetails.map((el) => {
          return {
            destinationSubLocationId: el.subLocationId,
            productId: el.id,
            quantity: el.quantity,
            inventoryId: el.inventoryId,
          };
        }),
      };
      try {
        const response = await this.$http.post(
          "/Inventories/stockTransfer",
          payload
        );
        if (response.ok) {
          this.close();
          this.$toast.success("Products transferred successfully", {
            icon: true,
            rtl: false,
          });
          this.cancel();
        }
      } catch (error) {
        this.close();
      }
      this.isBusyModal = false;
      this.close();
    },

    getSubLocationsById(e) {
      this.newItem.locationId = e.target.value;
      const res = this.SubLocations.filter(
        (el) =>
          el.location.id === e.target.value && el.id !== this.subLocationId
      );
      this.filteredSubLocations = res;
    },

    deleteAll() {
      this.transferDetails = [];
      this.close();
    },

    cancel() {
      $("#mod-confirms").modal("hide");
    },

    async initialize() {
      if (this.subLocationId) {
        this.isBusy = true;
        this.isBusyModal = true;

        await this.$http
          .get(`/SubLocations/${this.subLocationId}/products`)
          .then(function(res) {
            this.products = res.body;
          })
          .catch(function() {});

        this.isBusyModal = false;
        this.isBusy = false;

        this.viewAdds();
      }
    },

    viewAdds() {
      this.newItem = {
        productIndex: null,
        quantity: null,
        availableQuantity: null,
        productPrice: null,
        productId: null,
      };

      this.v2 = {
        productId: false,
        quantity: false,
        quantityError: false,
        locationId: false,
        subLocationId: false,
      };

      var fProducts = [];

      var details = this.transferDetails;

      this.products.forEach(function(e) {
        if (!details.some((s) => s.inventoryId == e.inventoryId)) {
          fProducts.push(e);
        }
      });

      this.filteredProducts = fProducts;

      $("#mod-adds").modal("show");
    },

    confirmTransfer() {
      $("#mod-confirms").modal("show");
    },
    add() {
      if (this.validateAdd()) {
        const newLocation = this.Locations.find(
          (el) => el.id === this.newItem.locationId
        );
        const newSubLocation = this.SubLocations.find(
          (el) => el.id === this.newItem.subLocationId
        );
        const p = {
          name: this.filteredProducts[this.newItem.productIndex].name,
          quantity: this.newItem.quantity,
          price: this.filteredProducts[this.newItem.productIndex].price,
          location: `${newLocation.name}, ${newSubLocation.name}`,
          id: this.newItem.productId,
          locationId: this.newItem.locationId,
          subLocationId: this.newItem.subLocationId,
          inventoryId: this.newItem.inventoryId,
        };
        this.transferDetails.push(p);
        $("#mod-adds").modal("hide");
        this.canShowCaution = false;
      }
    },

    validateAdd() {
      this.v2 = {
        productId: false,
        quantity: false,
        quantityError: false,
        locationId: false,
        subLocationId: false,
      };

      this.transferDetails.push(p);

      $("#mod-add").modal("hide");
      this.canShowCaution = false;
    },

    validateAdd() {
      this.v2 = {
        productId: false,
        quantity: false,
        quantityError: false,
        locationId: false,
        subLocationId: false,
      };
      var isValid = true;

      if (this.newItem.productIndex < 0) {
        this.v2.productId = true;
        isValid = false;
      }

      if (Number(this.newItem.quantity) <= 0) {
        this.v2.quantity = true;
        isValid = false;
      }

      if (Number(this.newItem.quantity) > this.newItem.availableQuantity) {
        this.v2.quantityError = true;
        isValid = false;
      }

      if (!this.newItem.locationId) {
        this.v2.locationId = true;
        isValid = false;
      }

      if (!this.newItem.subLocationId) {
        this.v2.subLocationId = true;
        isValid = false;
      }

      return isValid;
    },

    remove(index) {
      this.transferDetails.splice(index, 1);
    },

    formatMoney(val) {
      return helper.formatMoney(val);
    },

    async onProductSelect(event) {
      this.isQuantityLoading = true;
      const product = this.filteredProducts[this.newItem.productIndex];
      if (product) {
        this.checkQuantity(product);
        this.newItem.productPrice = product.price;
        this.newItem.productId = product.productId;
        this.newItem.inventoryId = product.inventoryId;
      }
      this.isQuantityLoading = false;
    },

    onQuantityChange(event) {
      const product = this.filteredProducts[this.newItem.productIndex];

      this.canShowCaution =
        this.newItem.availableQuantity - event.target.value <=
        product.minimumStockLevel;
    },

    onAddCancel() {
      this.canShowCaution = false;
    },
  },
};
</script>
